import { KeyConstructor } from './keyConstructor';
const SPACE_KEY = 'space';
const PAGE_KEY = 'page';
const SPACES_KEY = 'spaces';
const MEMBER_SPACES_KEY = 'memberSpaces';
const SPACES_BY_IDS_KEY = 'spacesByIds';
const SPACES_BY_SLUGS_KEY = 'spacesBySlugs';
const PINNED_POSTS_KEY = 'pinnedPosts';
export const getPageKey = KeyConstructor(PAGE_KEY);
export const getSpaceKey = KeyConstructor(SPACE_KEY);
export const getSpacesKey = KeyConstructor(SPACES_KEY);
export const getMemberSpacesKey = KeyConstructor(MEMBER_SPACES_KEY);
export const getSpacesByIdsKey = KeyConstructor(SPACES_BY_IDS_KEY);
export const getSpacesBySlugsKey = KeyConstructor(SPACES_BY_SLUGS_KEY);
export const getPinnedPostsKey = KeyConstructor(PINNED_POSTS_KEY);
//# sourceMappingURL=space.key.js.map